import { render, staticRenderFns } from "./treatments-filter-form.vue?vue&type=template&id=39a966bc&"
import script from "./treatments-filter-form.vue?vue&type=script&lang=ts&"
export * from "./treatments-filter-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports